import React from 'react';
import './ActivityTimelineSkeleton.scss';

const ActivityTimelineSkeleton = () => {
  return (
    <div className="mt-4">
      {[...Array(20)].map((_, index) => (
        <div key={index} className="timeline-skeleton-item">
          <div className="timeline-skeleton-avatar"></div>
          <div className="timeline-skeleton-content">
            <div className="timeline-skeleton-line" style={{ width: '80%', marginBottom: '0.5rem' }}></div>
            <div className="timeline-skeleton-line" style={{ width: '60%' }}></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ActivityTimelineSkeleton;
